import React from "react";
import { Link } from "react-router-dom";
import { Hammer, Building, ArrowRight } from "lucide-react";
import Reveal from "../Reveal";
import { RESIDENTIAL_SERVICES, COMMERCIAL_SERVICES } from "../../../lib/site";

const FeaturedServices = () => (
  <section id="services" className="py-20 md:py-24 bg-[#0A0A0A] scroll-mt-24" data-testid="featured-services-section">
    <div className="max-w-7xl mx-auto px-5 lg:px-12 text-left">
      <div className="mb-14 border-l-4 border-[#C69453] pl-6">
        <span className="text-[#C69453] text-sm font-semibold tracking-[0.2em] uppercase">Our Offerings</span>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-white mt-1">Industrial-Grade Coating Services</h2>
        <p className="text-zinc-400 text-base md:text-lg mt-3 max-w-2xl">
          Premium coatings for residential garages, patios, commercial spaces and industrial complexes across Northern Arizona.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-7">
          <div className="flex items-center space-x-3 mb-5">
            <Hammer className="text-[#C69453] w-6 h-6" />
            <h3 className="text-xl md:text-2xl font-bold tracking-tight text-white uppercase">Residential Coatings</h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {RESIDENTIAL_SERVICES.map((s, i) => (
              <Reveal key={s.title} delay={(i % 2) * 0.06}>
                <div className="border border-zinc-800 bg-[#141414] p-6 h-full">
                  <h4 className="text-lg font-bold text-white">{s.title}</h4>
                  <p className="text-zinc-400 text-sm mt-2 leading-relaxed">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Link to="/services" className="inline-flex items-center gap-2 mt-6 text-[#C69453] font-semibold hover:gap-3 transition-all">
            <span>View all residential services</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="lg:col-span-5 bg-zinc-950 border border-zinc-800 p-8 relative">
          <div className="absolute top-0 left-0 w-full h-1 bg-[#C69453]" />
          <div className="flex items-center space-x-3 mb-5">
            <Building className="text-[#C69453] w-6 h-6" />
            <h3 className="text-xl md:text-2xl font-bold tracking-tight text-white uppercase">Commercial &amp; Industrial</h3>
          </div>
          <p className="text-zinc-400 text-sm leading-relaxed mb-6">
            Commercial work is a key focus for PRYME EPOXY. We meet tight schedules and stringent code requirements.
          </p>
          <div className="space-y-5">
            {COMMERCIAL_SERVICES.slice(0, 3).map((s) => (
              <div key={s.title} className="border-l-2 border-[#C69453] pl-4">
                <h4 className="text-base font-bold text-white">{s.title}</h4>
                <p className="text-zinc-400 text-sm mt-1">{s.desc}</p>
              </div>
            ))}
          </div>
          <Link to="/commercial" className="inline-flex items-center gap-2 mt-6 text-[#C69453] font-semibold hover:gap-3 transition-all">
            <span>Explore commercial services</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default FeaturedServices;
